import React from 'react';
import Head from 'next/head';
import fs from 'fs';
import path from 'path';
import Layout from '../../components/Layout';

import OneistoxLearnerProfile from '../../components/OneistoxLearnerProfile';

interface Props {
  content: any;
}

const pillar = ({ content }: Props) => {
  return (
    <Layout>
      <Head>
        <title>{content?.meta?.title}</title>
        <meta name="description" content={content?.meta?.description} />
        <meta
          data-hid="twitterDescription"
          name="twitter:description"
          content={content?.meta?.description}
        />
        {content?.meta?.description && (
          <meta name="keywords" content={content.meta.keywords} />
        )}
        <meta
          property="og:image"
          content={`${process.env.NEXT_PUBLIC_CDN}${
            '/images/pillar/hero/' + content?.hero?.img ||
            '/images/metaImage/default.jpg'
          }`}
        />
        <meta
          name="twitter:image"
          content={`${process.env.NEXT_PUBLIC_CDN}${
            '/images/pillar/hero/' + content?.hero?.img ||
            '/images/metaImage/default.jpg'
          }`}
        />
        <meta property="og:image:type" content="image/jpeg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="627" />
        <meta property="og:image:alt" content={content?.meta?.title} />
      </Head>

      <OneistoxLearnerProfile data={content} />
    </Layout>
  );
};

export const getStaticPaths = async () => {
  const dirFiles = fs.readdirSync(path.join('content/community/learners'));

  const paths = dirFiles.map((name) => ({
    params: { url: name.split('.json')[0] },
  }));

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps = async ({ params: { url } }) => {
  const content = fs
    .readFileSync(path.join('content/community/learners/' + url + '.json'))
    .toString();

  return { props: { url, content: JSON.parse(content) } };
};

export default pillar;
